export const Lj_WORDS = ['LjUBAV', 'LjUTNjA', 'LjUSKA']
